import React from 'react';
import SmartText from '@reuters-graphics/react-smart-text';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const AsideBox = ({ title, source, context = {}, children, red = false, collapsible = false }) => {
  return (
    <section className={classnames(component)}>
      <div className='section-spacer-internal' />
      <div className={collapsible ? 'asideBox collapsible' : 'asideBox'}>
        <h4 className={red ? 'red' : ''}>{title}</h4>
        <SmartText
          source={source}
          context={context}
          multiline
        />
        {children}
      </div>
      <div className='section-spacer-internal' />
    </section>
  );
};

export default AsideBox;
